import axios from 'core/api'
import { 
  GetWaterQualityThresholdResponse, 
  UpdateWaterQualityThresholdRequest,
  UpdateWaterQualityThresholdResponse,
  WaterQualityThreshold,
  WaterQualityThresholdAgeRange,
  GetMealThresholdResponse,
  UpdateMealThresholdResponse,
  UpdateMealThreshold,
  GetShrimpHealthThresholdResponse,
  ShrimpHealthColor,
  ShrimpHealthTarget,
  ShrimpHealthThresholdAgeRange,
  UpdateShrimpHealthThresholdResponse,
} from './types'

export const getWaterQualityThreshold = () =>
  axios.get<GetWaterQualityThresholdResponse>('/water-quality-threshold')

export const updateWaterQualityThresholdByParameter = ({ parameter, data }: { parameter: string; data: Omit<WaterQualityThreshold, 'parameter' | 'age_ranges'> }) =>
  axios.patch<UpdateWaterQualityThresholdResponse>(`/water-quality-threshold/${parameter}`, data)

export const updateWaterQualityThresholdAgeRanges = ({
  parameter,
  ageRanges,
}: {
  parameter: string
  ageRanges: WaterQualityThresholdAgeRange[]
}) =>
  axios.put<UpdateWaterQualityThresholdResponse>(`/water-quality-threshold/${parameter}/age-ranges`, {
    age_ranges: ageRanges,
  })

export const getMealThreshold = () =>
  axios.get<GetMealThresholdResponse>('/meal-threshold')

export const updateMealThresholdByParameter = ({ parameter, data }: { parameter: string; data: Omit<UpdateMealThreshold, 'parameter'> }) =>
  axios.patch<UpdateMealThresholdResponse>(`/meal-threshold/${parameter}`, data)

// NK-273
export const getShrimpHealthThreshold = () =>
  axios.get<GetShrimpHealthThresholdResponse>('/shrimp-health-threshold')

export const updateShrimpHealthThresholdActive = ({
  target,
  color,
  isActive,
}: {
  target: ShrimpHealthTarget
  color: ShrimpHealthColor
  isActive: boolean
}) =>
  axios.patch<UpdateShrimpHealthThresholdResponse>(`/shrimp-health-threshold/${target}/${color}`, {
    is_active: isActive,
  })

export const updateShrimpHealthThresholdAgeRanges = ({
  target,
  color,
  ageRanges,
}: {
  target: ShrimpHealthTarget
  color: ShrimpHealthColor
  ageRanges: ShrimpHealthThresholdAgeRange[]
}) =>
  axios.put<UpdateShrimpHealthThresholdResponse>(`/shrimp-health-threshold/${target}/${color}/age-ranges`, {
    age_ranges: ageRanges,
  })
